import React, { createContext, useState, useContext } from "react";
import type {
  FactoringInput,
  FactoringEntryInput,
} from "components/factoringModel";

interface FactoringContextType {
  factoring: FactoringInput;
  setFactoring: React.Dispatch<React.SetStateAction<FactoringInput>>;
  imageFiles: File[];
  setImageFiles: React.Dispatch<React.SetStateAction<File[]>>;
  entries: FactoringEntryInput[];
  setEntries: React.Dispatch<React.SetStateAction<FactoringEntryInput[]>>;
  reset: () => void;
}

const initialFactoring: FactoringInput = {
  desiredAmount: 0,
  notes: "",
  personalInfoConsent: false,
};

const FactoringContext = createContext<FactoringContextType>({
  factoring: initialFactoring,
  setFactoring: () => {},
  imageFiles: [],
  setImageFiles: () => {},
  entries: [],
  setEntries: () => {},
  reset: () => {},
});

export const FactoringProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [factoring, setFactoring] = useState<FactoringInput>(initialFactoring);
  const [imageFiles, setImageFiles] = useState<File[]>([]);
  const [entries, setEntries] = useState<FactoringEntryInput[]>([]);

  const reset = () => {
    setFactoring(initialFactoring);
    setImageFiles([]);
    setEntries([]);
  };

  return (
    <FactoringContext.Provider
      value={{
        factoring,
        setFactoring,
        imageFiles,
        setImageFiles,
        entries,
        setEntries,
        reset,
      }}
    >
      {children}
    </FactoringContext.Provider>
  );
};

export const useFactoring = () => useContext(FactoringContext);
